import jwtDecode from 'jwt-decode';

export const getSubFromToken = token => {
  try {
    return token ? jwtDecode(token).sub : '';
  } catch (e) {
    return '';
  }
};
